(function () {
  // Product cards on the homepage ("Shop the Calm Collection" etc.) show
  // the featured image in a fixed 1:1 square with object-fit: cover. That's
  // right for normal square/portrait product photos, but kit/bundle
  // products use a single wide banner-style composite image (multiple
  // items side by side with captions baked in), and cover-cropping that
  // down to a square shows only an unrecognizable sliver of one item.
  // Measure each card image's real aspect ratio once it loads and switch
  // to object-fit: contain for anything unusually wide, so the whole
  // composite stays visible (letterboxed) instead of being cropped.
  function applyFit(img) {
    if (!img.naturalWidth || !img.naturalHeight) return;
    var ratio = img.naturalWidth / img.naturalHeight;
    if (ratio > 1.6) {
      img.style.objectFit = 'contain';
      img.style.backgroundColor = '#F3F1EA';
    }
  }

  function scan() {
    document.querySelectorAll('.luma-product-card__img-wrap img').forEach(function (img) {
      if (img.complete) {
        applyFit(img);
      } else {
        img.addEventListener('load', function () { applyFit(img); }, { once: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();
